module.exports = __webpack_public_path__ + "static/media/icon_api_gray.d50d605d.png";